import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { rule_id: string };

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useDeleteAutoReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while deleting the auto-reply rule',
    endpoint: ({ rule_id }) => `/api/admin/whatsapp/auto-reply/${rule_id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
